// Not-found page in the public identity: says what happened and offers the
// real destinations instead of a dead end.

import { Link } from 'wouter';
import { AppLink, ArrowRight } from './chrome';
import { SitePage } from './SitePage';

export function NotFound({ launchHref }: { launchHref: string }) {
  return (
    <SitePage launchHref={launchHref} title="Page not found · ZeroQube">
      <section className="notfound" aria-labelledby="notfound-title">
        <div className="container">
          <p className="notfound-code" aria-hidden="true">
            404
          </p>
          <h1 id="notfound-title" className="display">
            Nothing here.
          </h1>
          <p className="lede">This address does not match a page. Your vault is not affected.</p>
          <div className="notfound-actions">
            <Link href="/" className="btn btn-secondary btn-lg">
              Home
            </Link>
            <AppLink href={launchHref} className="btn btn-primary btn-lg">
              Enter app
              <ArrowRight />
            </AppLink>
          </div>
        </div>
      </section>
    </SitePage>
  );
}
